module.exports = __webpack_public_path__ + "assets/img/detail-head-back-.b252aaf7.png";